/** Мутация создания проекта. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { AnalyticsGoal, trackGoal } from "@/shared/lib/analytics";
import { projectsKeys } from "./keys";

export const useCreateProject = () => {
	const mutation = useMutation({
		mutationFn: Api.Project.postApiProjects,
		mutationKey: projectsKeys.create,
		onSuccess: (response) => {
			if (response.data !== null) trackGoal(AnalyticsGoal.ProjectCreated);
		},
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
